import Canvas from "../../Canvas/Canvas";

function CanvasArea() {
  return <Canvas />;
}

export default CanvasArea;
